// src/utils/orderFormFields.js
export const ORDER_FORM_FIELDS_NAMESPACE = 'orderFormFields';

export const CONFIGURABLE_ORDER_FIELDS = [
  'privateReference',
  'customerEmail',
  'deliveryNotes',
  'specialNotes',
  'orderOriginKey',
];

export const getRequiredOrderFields = (settings) =>
  settings?.enabled ? (settings.requiredFields || {}) : {};
